import Quotation from "../../pages/file/quotation";

export const fileMenus = [
    {
        menuCode: 'F-Q',
        menuComponent: <Quotation />
    },
];